<script lang='ts'>
  import EditorLeftPane from './EditorLeftPane.svelte';
  import type { Storefront } from 'app/javascript/shared/javascripts/types/Storefront';
  import ProductChooserModal from '../Components/Editor/ProductChooserModal.svelte';
  import Spinner from '@shared/svelte/Components/Spinner.svelte';
  export let callbacks: any;
  export let storefront : Storefront;

  let loading:boolean = true;

  let shouldShowProductChooser:boolean = false;

  $: pcArgs = {};

  callbacks.showProductChooser = function(args: any) {
    pcArgs = args;
    shouldShowProductChooser = true;
  }

  function onCloseProductChooser() {
    shouldShowProductChooser = false;
  }

  function oniframeLoad() {
    loading = false;
  }

</script>

<aside data-grid-area="aside">
  <EditorLeftPane {storefront} {callbacks}></EditorLeftPane>
</aside>

<main data-grid-area='main'>
  {#if loading}
    <Spinner></Spinner>
  {/if}
  <iframe src='/distributor/storefronts/preview_content/{storefront.distributor_id}'
    title="preview" class='fizz-iframe fizz-floating'
    id='storefront-preview-content'
    on:load={oniframeLoad} />
</main>

<ProductChooserModal
  {callbacks} {onCloseProductChooser}
  bind:shouldShowProductChooser
  {...pcArgs}
  ></ProductChooserModal>